import React from 'react';
import classNames from 'classnames';

import css from './IconUserCircle.module.css';

/**
 * Account icon: a person inside a circle.
 *
 * Outline by default. When `isFilled` is set the disc takes the forest-green CTA
 * fill and the person is knocked out in cream — the state used for a signed-in
 * user who hasn't uploaded a profile image.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {boolean} props.isFilled
 * @returns {JSX.Element} user circle icon
 */
const IconUserCircle = props => {
  const { className, rootClassName, isFilled = false } = props;
  const classes = classNames(rootClassName || css.root, className, {
    [css.filled]: isFilled,
  });

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Disc is drawn first so the person stays on top of it when filled. */}
      <path
        className={css.disc}
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      />
      <path d="M14.9961 10C14.9961 11.6569 13.6529 13 11.9961 13C10.3392 13 8.99609 11.6569 8.99609 10C8.99609 8.34315 10.3392 7 11.9961 7C13.6529 7 14.9961 8.34315 14.9961 10Z" />
      <path d="M18.4984 19.1511C17.3377 17.4018 15.2947 16.2009 12.9313 16.0569L11.9984 16C11.6652 16.0083 11.3547 16.0194 11.0617 16.0325C8.71722 16.1376 6.66598 17.3796 5.5 19.1511" />
    </svg>
  );
};

export default IconUserCircle;
